module.exports = "mutation ($taskHash: String!, $taskData: String!) {\n    userapiTaskStatusChanged(taskHash: $taskHash, taskData: $taskData)\n}"